var digistorm = {

    init: function () {

        // load calendars
        this.calendars();
        this.tags();
    },

    calendars: function () {
        var _self = this;

        $('#calendar-category-select').change(function() {
            var value = $(this).val();
            document.location = '?category=' + value;
        });

        console.log(getParameterByName('category'));

        $('[data-calendars]').each(function() {
            var calendarUrl = $(this).attr('data-calendar-url');
            var calendarTimezone = $(this).attr('data-calendar-timezone');
            var monthHeader = $(this).attr('data-calender-header') === '1'; ;

            $('.calendar-desktop').fullCalendar({
                events: function (start,end,timezone,callback) {
                    if (getParameterByName('category') == ""){
                        var url = calendarUrl + "?start=" + start.unix() + "&end=" + end.unix()
                    }else{
                        var url = calendarUrl + "?start=" + start.unix() + "&end=" + end.unix() + '&tag_ids[]=' + getParameterByName('category') + '&exclude_untagged=true'
                    }
                    $.ajax({url: url}).done(function (response){callback(response)});
                },
                eventDataTransform: function (e) {
                    var start = moment.tz(parseInt(e.start_time) * 1000, calendarTimezone);
                    e.start = start.format();
                
                    if (e.end_time != null) {
                        var end = moment.tz(parseInt(e.end_time) * 1000, calendarTimezone);
                        if (!start.isSame(end, 'day')) {
                            end.add(1, 'days');
                        }
                        e.end = end.format();
                    }
                
                    if (e.all_day || e.allDay) {
                        e.allDay = true;
                    }
                    
                    if (e.tags) {
                        e.tags.forEach(function(tag){
                            e.color = tag.color;
                        })
                    }
                
                    // Decode the title to handle HTML entities like &#39;
                    e.title = $('<textarea>').html(e.title).text();
                
                    return e;
                },
                editable: false,
                timeFormat: 'h:mm A',
                ...(monthHeader && {
                    header: {
                        left: 'prev, next today',
                        center: 'title',
                        right: 'month,agendaWeek,agendaDay'
                    },
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }),
                aspectRatio: '1.8',
                timezone: calendarTimezone,
                eventClick: function (event, jsEvent, view) {

                    var $target = $(jsEvent.target)
                    var $event = $target.closest('.fc-event-container');
                    var $modal = $event.find('.cal-modal');

                    if (!$target.closest('.cal-modal').length) { // if not clicking the modal
                        if (!$modal.length) { // add the modal if it doesn't exist

                            $modal = _self.createEventModal(event);
                            $event.append($modal);

                            setTimeout(function () {
                                $modal.addClass('active')
                            }, 100);
                        } else {
                            $modal.addClass('active');
                        }
                    }
                }
            });

           var tagIds = getParameterByName('category', false);
            var mobilecalendarUrl = '';
            if (tagIds) {
                    mobilecalendarUrl += calendarUrl + '?tag_ids[]=' + tagIds + '&exclude_untagged=true';
            }else{
                mobilecalendarUrl += calendarUrl;
            }
            $('.calendar-mobile').digistormMobileCalendar({
                url: mobilecalendarUrl,
                timezone: calendarTimezone,
                eventDataTransform: function(event) {
                    event.start = event.start_time;
                    event.end = event.end_time;
                    return event;
                }
            });
        })
    },

    tags: function () {

        function getParameterByName(name, url) {
            var values = []
            if (!url) url = location.href

            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]")

            var pattern = name + '=([^&#]+)'
            var o_reg = new RegExp(pattern,'ig')
            while (true){
                var matches = o_reg.exec(url)
                if (matches && matches[1]){
                    values.push(matches[1])
                } else {
                    break
                }
            }

            if (!values.length){
                return null
            } else {
                return values
            }
        }

        $.ajax({
	    	url: "/api/tagCategories.php",
	    	dataType: "json",
	    	type: "GET",
	    	success: function(response) {
	    		$.each(response, function(index, tag_group) {

	    			$('#calendar-category-select').append($("<option>").attr('value', tag_group.id).text(tag_group.name));

	    		});

	    		var tag_id = getParameterByName('category');
    		 	tag_id ? $('#calendar-category-select').val(tag_id) : "";
    		 	if (tag_id) {
    		 		var tag_name = $('.calendar-category-select').find('option[value="'+tag_id+'"]').html();
    		 		$('.tag-name').html(tag_name + ' Calendar');
    		 	}


	    	},
	    	error: function(err) {
	    		console.log(err);
	    	}

        });
    },

    // create modal from reach event
    createEventModal: function (event) {
        $modal = $('<div class="cal-modal"></div>');
        var $holder = $('<div class="content-holder"></div>')
        var $content = $('<div class="content"></div>');

        $content.append('<h2>' + event.title + '</h2>');

        var mStart = moment.tz(parseInt(event.start_time) * 1000, event.timezone);
        var mEnd = moment.tz(parseInt(event.end_time) * 1000, event.timezone);
        if (mStart.isSame(mEnd,'day')) {
            if (event.allDay) {
                $content.append('<small>'+mStart.format('D MMMM')+' (All Day)</small>');
            } else {
                if(mStart.format('h:mma') == mEnd.format('h:mma')){
                    $content.append('<small>'+mStart.format('D MMMM')+' (All Day)</small>');
                }else{
                    $content.append('<small>'+mStart.format('D MMMM')+' (' + mStart.format('h:mma') + ' - ' + mEnd.format('h:mma') + ')</small>');
                }
            }
        } else{
            $content.append('<small>' + mStart.format('D MMM') + ' - ' + mEnd.format('D MMM') + '</small>');
        }
        $content.append('<p>' + event.body + '</p>');

        if(event.location.length > 0) {
            $content.append('<p>' +'<i class="fa fa-map-marker"></i> ' + event.location + '</p>');
        }

        console.log(event.attachments);
        console.log(event.attachments.length);
        if (event.attachments && event.attachments.length) {
            $.each(event.attachments, function (i, attachment) {
                console.log(attachment.type);
                switch (attachment.type) {
                    case 'address':
                        $content.append('<div class="attachment attachment-address"><i class="fa fa-map-marker"></i> ' + String(attachment.address).replace("\n", '<br>') + '</div>');
                        break;
                    case 'contact':
                        var contact_details = [];
                        if (attachment.contact_name) {
                            contact_details.push(attachment.contact_name);
                        }
                        if (attachment.contact_phone) {
                            contact_details.push($('<a>').attr('href', 'tel:' + attachment.contact_phone ).text(attachment.contact_phone ).prop('outerHTML'));
                        }
                        if (attachment.contact_email) {
                            contact_details.push($('<a>').attr('href', 'mailto:' + attachment.contact_email ).text(attachment.contact_email ).prop('outerHTML'));
                        }
                        $content.append('<div class="attachment attachment-contact"><i class="fa fa-phone"></i> ' + contact_details.join('<br>') + '</div>');
                        break;
                    case 'link':
                        $content.append('<div class="attachment attachment-link"><i class="fa fa-link"></i> ' + $('<a target="blank">').attr('href', attachment.url).text(attachment.url).prop('outerHTML')  + '</div>');
                        break;
                    case 'file':
                        $content.append('<div class="attachment attachment-file"><i class="fa fa-file"></i> ' + $('<a target="blank">').attr('href', attachment.url).text(attachment.file_name).prop('outerHTML') + '</a></div>');
                        break;
                }
            });
        }

        $modal.click(function (event) {
            if ($(event.target).hasClass("cal-modal") || $(event.target).hasClass("close") || $(event.target).hasClass("content-holder")) {
                $(this).removeClass('active');
            }
        });

        $holder.append('<div class="close"></div>');
        $holder.append($content);
        $modal.append($holder);

        return $modal;
    },

}

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// Yo!
$(document).ready(function () {
    digistorm.init();
});
